<template>
	<div class="stacked" :class="{ 'stacked--expired': expired }">
		<button class="stacked__remove" @click="removeBet()">
			<svg width="19" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path opacity="1" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="var(--light-dark-blue)"/>
				<path d="M13.06 12L15.36 9.7C15.65 9.41 15.65 8.93 15.36 8.64C15.07 8.35 14.59 8.35 14.3 8.64L12 10.94L9.69998 8.64C9.40998 8.35 8.92999 8.35 8.63999 8.64C8.34999 8.93 8.34999 9.41 8.63999 9.7L10.94 12L8.63999 14.3C8.34999 14.59 8.34999 15.07 8.63999 15.36C8.78999 15.51 8.97999 15.58 9.16999 15.58C9.35999 15.58 9.54998 15.51 9.69998 15.36L12 13.06L14.3 15.36C14.45 15.51 14.64 15.58 14.83 15.58C15.02 15.58 15.21 15.51 15.36 15.36C15.65 15.07 15.65 14.59 15.36 14.3L13.06 12Z" fill="var(--white)"/>
			</svg>
		</button>
		<div class="stacked__details">
			<div class="stacked__row stacked__row--top">
				<span>
					<span class="stacked__display bold">
						<router-link class="stacked__link" :to="getRoute()">{{
							bet.game_description | toTitleCase
						}}</router-link>
					</span>
				</span>
			</div>
			<div class="stacked__row stacked__market">
				<span>{{ bet.odd.name | toTitleCase }}</span> •
				<span class="stacked__row stacked__market--odd"
					>{{ bet.odd.odd_key | toTitleCase }}
					<!-- {{ getSpecialBetValue() | toTitleCase }} -->
				</span>
			</div>
			<div
				class="stacked__row stacked__row--bottom"
				v-show="!expired"
			>
				<span
					v-if="!expired"
					class="stacked__marker stacked__marker--starttime"
				>
					<span>{{this.$t('betslip.starts')}} {{ bet.start_time | time }}</span>
				</span>
			</div>
		</div>
		<div class="stacked__row stacked__row--middle">
			<span class="odd-value bold" v-if="!expired">{{
				bet.odd.odd_value
			}}</span>
		</div>
		<div
			class="stacked__row stacked__row--bottom"
			:class="{ 'stacked__row--bottom--expired': expired }"
			v-if="expired"
		>
			<div>
				<span class="stacked__marker stacked__marker--expired"
					>{{this.$t('prebets.started')}}</span
				>
			</div>
		</div>
		<span
			class="underline_slip"
			:class="{
				'd-none': keyValue === 1,
			}"
		></span>
	</div>
</template>

<script>
export default {
	name: "bet",
	props: ["bet", "currentTime", "keyValue"],
	computed: {
		expired() {
			return false;
			return (
				+new Date(this.bet.start_time.replace(/-/g, "/")) <= this.currentTime
			);
		},
	},
	methods: {
		removeBet() {
			let vm = this;
			vm.$store.commit("removeFromVirtualBetslip", vm.bet.parent_virtual_id);
		},
		getSpecialBetValue() {
			return this.bet.odd.special_bet_value
				? `(${this.bet.odd.special_bet_value})`
				: "";
		},
		getRoute() {
			return `/virtuals/markets?id=${this.bet.parent_virtual_id}`;
		},
	},
};
</script>
